import { RootState } from './index'
import { Module } from 'vuex'


declare interface AlertState {
  show: boolean;
  message: string;
  color: string;
}

export const alert: Module<AlertState, RootState> = {
  state: {
    show: false,
    message: '',
    color: '',
  },

  mutations: {
    SET_SHOW (state, show) { state.show = show },
    SET_MESSAGE (state, message) { state.message = message },
    SET_COLOR (state, color) { state.color = color },
  },

  actions: {
    alertMessage (context, payload) {
      let message, color

      if (typeof payload === 'string') {
        message = payload
        color = 'info'
      }
      else {
        message = payload.message
        color = payload.color || 'info'
      }

      context.commit('SET_MESSAGE', message)
      context.commit('SET_COLOR', color)
      context.commit('SET_SHOW', true)
    },

    discardMessage (context) {
      context.commit('SET_SHOW', false)
      context.commit('SET_MESSAGE', '')
      context.commit('SET_COLOR', '')
    }
  },
}
